import React from 'react';

import classes from 'components/common/Tables/MainTable/MainTable.module.scss';
import HeaderCell from 'components/common/Tables/MainTable/components/HeaderRow/components/HeaderCell/HeaderCell';

const HeaderRow = ({ headerGroups }) => {
    return headerGroups.map((headerGroup) => {
        const { key, ...HeaderGroupProps } = headerGroup.getHeaderGroupProps();
        return (
            <div data-testid={'header-row'} key={key} className={classes.headerRow} {...HeaderGroupProps}>
                {headerGroup.headers.map((column) => {
                    return <HeaderCell key={column.id} column={column} />;
                })}
            </div>
        );
    });
};

export default HeaderRow;
